import { ErrorOutlineRounded } from '@mui/icons-material'
import { ConsultationCard } from 'feature/appeals/components/ConsultationCard/ConsultationCard'
import { useGetConsultationQuery } from 'feature/appeals/redux/appeals.api'
import { InformationCard } from 'feature/informationCard'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import useRequestTimeout from 'router/hooks/useRequestTimeout'
import { LoaderInCentalPosition } from 'widget'

export const AppealDetailConsultation = () => {
  const params = useParams()
  const appealUid = params.uid
  const [isRequestWithError, setRequestWithError] = useState<boolean>(false)
  const { isTimeUp, Modal } = useRequestTimeout()
  const { isLoading, data, isError } = useGetConsultationQuery(
    appealUid || '',
    {
      pollingInterval: 10000,
      skip: isTimeUp || isRequestWithError,
    },
  )

  useEffect(() => {
    if (isError) setRequestWithError(isError)
  }, [isError])

  if (isLoading) return <LoaderInCentalPosition />

  if (!data || data instanceof Error)
    return (
      <InformationCard
        title='ошибка 404'
        subtitle='Страница не найдена'
        Icon={<ErrorOutlineRounded fontSize='large' color='primary' />}
        link='/'
        linkText='На главную'
      />
    )

  return (
    <>
      <ConsultationCard data={data} />
      {Modal}
    </>
  )
}
